import React from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { useUserState } from 'contexts/auth-context';
import t from 'utils/translateFunc';

import { BtnDropCircle } from '../../Elements/Elements';

import { menuConfig } from 'data/dropDownConfig';

import classes from './ChipsButton.module.scss';

const ChipsButton = ({
  name,
  id,
  index,
  manyTabs,
  onClickChips,
  modeWidth,
  modeSetting,
  handleDelRelease,
  handleRename,
  modeUser
}) => {
  const language = useUserState().user.language;

  const params = useParams();

  const onSelectOption = mode => {
    if (mode === 'del') {
      handleDelRelease(id);
    } else {
      handleRename(id);
    }
  };

  return (
    <div
      className={cn(
        classes.underlineChips,
        manyTabs
          ? classes.underlineChips_manyTabs
          : classes.underlineChips_oneTabs,
        id === Number(params.releaseId) &&
          classes.underlineChips_manyTabs_isChecked,
        id === modeSetting && classes.underlineChips_manyTabs_isChecked
      )}
    >
      <div className={classes.chipsButtonWrap}>
        <button
          onClick={() => onClickChips(id)}
          type="button"
          className={cn(
            classes.chipsButton,
            manyTabs
              ? classes.chipsButton_manyTabs
              : classes.chipsButton_oneTabs,
            modeWidth && index === 0 && classes.chipsButton_modeWidth
          )}
        >
          {!modeWidth ? (
            <p className={cn(classes.hiddenText, classes.name)}>
              {manyTabs ? `${name}.` : name}&ensp;
            </p>
          ) : (
            <p className={cn(classes.hiddenText, classes.name)}>{name}</p>
          )}
          {manyTabs && !modeWidth && (
            <p className={classes.option}>
              {t('chipsButton', 'OPTION', language)}&ensp;
              {index + 1}
            </p>
          )}
        </button>
        {!modeWidth && !modeUser && (
          <div
            className={cn(
              classes.buttonPosition,
              manyTabs
                ? classes.buttonPosition_manyTabs
                : classes.buttonPosition_oneTabs
            )}
          >
            <BtnDropCircle
              arrow
              menuConfig={menuConfig}
              selectOption={onSelectOption}
              manyTabs={manyTabs}
            />
          </div>
        )}
      </div>
    </div>
  );
};

ChipsButton.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  index: PropTypes.number.isRequired,
  manyTabs: PropTypes.bool,
  onClickChips: PropTypes.func.isRequired,
  modeWidth: PropTypes.bool,
  modeSetting: PropTypes.string,
  handleDelRelease: PropTypes.func,
  handleRename: PropTypes.func,
  modeUser: PropTypes.bool
};

export default ChipsButton;
